const DAILY_METRICS_COLLECTION = "daily_metrics";

const processDoc = (doc) => {
  return { id: doc.id, ...doc.data() };
};

function DailyMetricsMixin() {
  return {
    async getDailyMetricsByCampaignId(campaignId) {
      const snapshot = await this.collection(DAILY_METRICS_COLLECTION)
        .where("campaignId", "==", campaignId)
        .get();
      return snapshot.docs.map(processDoc);
    },

    async getAllDailyMetrics() {
      const snapshot = await this.collection(DAILY_METRICS_COLLECTION).get();
      return snapshot.docs.map(processDoc);
    },

    async updateDailyMetrics(id, data) {
      await this.collection(DAILY_METRICS_COLLECTION).doc(id).update(data);
    }
  };
}

module.exports = DailyMetricsMixin;
